import React from "react";
import { XMarkIcon, BookOpenIcon } from "@heroicons/react/24/outline";

const formatDateTime = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (isNaN(d)) return v;
  return d.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export default function ViewVoterEducationInfo({ isOpen, onClose, resource }) {
  if (!isOpen || !resource) return null;
  console.log('resource ', resource);

  const fileType = resource.media?.type?.toLowerCase() || "";
  const isPDF = fileType === "pdf";
  const isLink = fileType === "link" || (!isPDF && resource.media?.link);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-5xl rounded-xl shadow-lg relative p-6 animate-in slide-in-from-top duration-300">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-transform transform hover:rotate-90 duration-200"
        >
          <XMarkIcon className="w-6 h-6 text-gray-600" />
        </button>

        {/* Header */}
        <h2 className="text-xl font-bold mb-4">Educational Resource Details</h2>

        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Panel */}
          <div className="md:w-1/3 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 flex items-center justify-center bg-blue-100 text-blue-600 rounded-full">
                <BookOpenIcon className="w-6 h-6" />
              </span>
              <h3 className="font-semibold text-gray-800">{resource.title}</h3>
            </div>

            <p className="text-gray-600 text-sm mb-4">{resource.description}</p>

            <div className="text-sm space-y-2">
              <div>
                <p className="text-gray-500 font-medium">Date Uploaded</p>
                <p className="text-gray-800">
                  {formatDateTime(resource.updated_at)}
                </p>
              </div>
              <div>
                <p className="text-gray-500 font-medium">Resource Type</p>
                <p className="text-gray-800">
                  {isPDF
                    ? `PDF Document (${resource.size || "2.4 MB"})`
                    : "External Link"}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="md:w-2/3 border rounded-lg flex flex-col overflow-hidden">
            <div className="bg-gray-100 px-4 py-2 font-semibold text-gray-700 flex items-center justify-between">
              <span>{isPDF ? "PDF Preview" : "External Link"}</span>
              {isPDF && (
                <button
                  className="text-sm text-blue-600 hover:underline"
                  onClick={() => window.open(resource.media?.link, "_blank")}
                >
                  Full Screen
                </button>
              )}
            </div>

            <div className="flex-1 bg-white p-6 overflow-auto text-center">
              {isPDF ? (
                <iframe
                  src={resource.media?.link}
                  className="w-full h-[400px] border rounded-md"
                  title="PDF Preview"
                />
              ) : isLink ? (
                <div className="flex flex-col items-center justify-center h-full">
                  <p className="text-gray-600 mb-2">
                    Click the link below to view this resource:
                  </p>
                  <a
                    href={resource.media?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 font-medium underline break-all"
                  >
                    {resource.media?.link}
                  </a>
                </div>
              ) : (
                <div className="text-gray-500 italic">
                  Preview not available for this file type.
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Download Button */}
        {isPDF && (
          <div className="mt-6 flex justify-end">
            <a
              href={resource.media?.link}
              download
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              Download PDF
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
